export default __webpack_public_path__ + "static/media/SHIB-BNB.a478fecb.svg";